module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"help":{"login":"Please log in to map or edit this sector.","change_back":"Please change the state to \u0027Being edited\u0027 to edit this sector."}},"ko":{"help":{"login":"이 부분의 지도를 제작하거나 편집하려면 로그인하세요.","change_back":null}}}')
  delete Component.options._Ctor
}
